/**
 * @generated SignedSource<<febcec09fcfe71e5c9b668e6858238c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_groupResults$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"groupRow_nativeIssueTable_groupRow">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly firstGroup?: {
    readonly id: string;
    readonly issues: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraIssueEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"groupRow_nativeIssueTable_FirstGroupRow_firstGroupRow">;
  } | null | undefined;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_groupResults";
};
export type groupTableBody_nativeIssueTable_groupResults$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_groupResults">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_groupResults",
  "selections": [
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "fieldSetsInput",
                  "variableName": "fieldSetsInput"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 50
                }
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "issues",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isDensityFull",
                  "variableName": "isDensityFull"
                },
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                },
                {
                  "kind": "Variable",
                  "name": "projectKey",
                  "variableName": "projectKey"
                },
                {
                  "kind": "Variable",
                  "name": "projectKeys",
                  "variableName": "projectKeys"
                }
              ],
              "kind": "FragmentSpread",
              "name": "groupRow_nativeIssueTable_FirstGroupRow_firstGroupRow"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "groupRow_nativeIssueTable_groupRow"
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "84f513dcd3de1058066815ffc95002e0";

export default node;
